var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"dark",attrs:{"id":"breadcrumbs"}},[_c('ul',_vm._l((_vm.breadCrumbs),function(item){return _c('li',[_c('NuxtLink',{attrs:{"to":item.url}},[_vm._v(_vm._s(item.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }